import { render, staticRenderFns } from "./NewBuildingConstruction.vue?vue&type=template&id=7879a75e&"
import script from "./NewBuildingConstruction.vue?vue&type=script&lang=js&"
export * from "./NewBuildingConstruction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports